import React from "react";
import { Modal } from "react-bootstrap";
import userService from "../_services/user.service";

class UpdateProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.updateUser,
      errors: {},
      isFormValid: false,
      message: "",
      isUpdated: false,
    };
    this._handleRadio = this._handleRadio.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  _handleRadio(event) {
    const isEnabled = event.currentTarget.value === "true" ? true : false;
    let user = this.state.user;
    user.enabled = isEnabled;
    this.setState({ user: user });
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { user, errors } = this.state;

    const re = /^[0-9\b]+$/;
    if (name === "contact") {
      if (value === "" || re.test(value)) {
        this.setState({
          user: {
            ...user,
            [name]: value,
          },
          errors: {
            ...errors,
            [name]: "",
          },
        });
      } else {
        this.setState({
          errors: {
            ...errors,
            [name]: "Only numbers are allowed",
          },
        });
      }
    } else {
      this.setState({
        user: {
          ...user,
          [name]: value,
        },
        errors: {
          ...errors,
          [name]: "",
        },
      });
    }
  }
  handleSubmit() {
    if (this.validateForm()) {
      const { user } = this.state;
      let formData = JSON.stringify(user);

      userService
        .update(formData)
        .then((data) => this.responseShow(data))
        .catch((error) => console.log("Error :" + error));
    }
  }
  responseShow(obj) {
    this.setState({ isUpdated: obj.isSuccess, message: obj.message });
  }
  validateForm() {
    let { user } = this.state;
    let errors = {};
    let isFormValid = true;

    if (!user.firstName) {
      isFormValid = false;
      errors["firstName"] = "Enter First Name";
    }
    if (!user.lastName) {
      isFormValid = false;
      errors["lastName"] = "Enter Last Name";
    }

    if (!user.contact) {
      isFormValid = false;
      errors["contact"] = "Enter Contact No";
    }

    this.setState({
      errors: errors,
    });
    return isFormValid;
  }

  render() {
    const { user, message, isUpdated } = this.state;
    const { updateClose } = this.props;
    return (
      <React.Fragment>
        <Modal
          show="true"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <Modal.Title>Update User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-sm-12">
                <div className="box box-primary">
                  <form name="form">
                    <div className="box-body">
                      <div className="row">
                        <div className="col-sm-12">
                          {message && (
                            <div class="alert alert-success" role="alert">
                              {message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="firstName">First Name</label>
                            <input
                              id="firstName"
                              name="firstName"
                              value={user.firstName}
                              onChange={this.handleChange}
                              maxLength="20"
                              type="text"
                              className={
                                "form-control" +
                                (this.state.errors.firstName ? " invalid" : "")
                              }
                              placeholder="First Name"
                            />
                            {this.state.errors.firstName && (
                              <small class="help-block">
                                {this.state.errors.firstName}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="lastName">Last Name</label>
                            <input
                              id="lastName"
                              name="lastName"
                              value={user.lastName}
                              onChange={this.handleChange}
                              maxLength="20"
                              type="text"
                              className={
                                "form-control" +
                                (this.state.errors.lastName ? " invalid" : "")
                              }
                              placeholder="Last Name"
                            />
                            {this.state.errors.lastName && (
                              <small class="help-block">
                                {this.state.errors.lastName}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label htmlFor="contact">Contact No</label>
                          <input
                            id="contact"
                            name="contact"
                            value={user.contact}
                            onChange={this.handleChange}
                            maxLength="10"
                            type="text"
                            className={
                              "form-control" +
                              (this.state.errors.contact ? " invalid" : "")
                            }
                            placeholder="Contact No"
                          />
                          {this.state.errors.contact && (
                            <small class="help-block">
                              {this.state.errors.contact}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <label>Enable</label>
                        <div className="form-group">
                          <div class="form-check form-check-inline">
                            <label>
                              <input
                                class="form-check-input"
                                type="radio"
                                name="isEnabled"
                                value="true"
                                checked={user.enabled === true}
                                onChange={this._handleRadio}
                              />
                              Yes
                            </label>
                          </div>
                          <div class="form-check form-check-inline">
                            <label>
                              <input
                                class="form-check-input"
                                type="radio"
                                name="isEnabled"
                                value="false"
                                checked={user.enabled === false}
                                onChange={this._handleRadio}
                              />
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 text-center">
                        <hr />
                        <button
                          type="button"
                          onClick={this.handleSubmit}
                          className="btn btn-primary btn-sm ml-2 ts-buttom btn btn-primary"
                        >
                          Update
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          onClick={() => updateClose(isUpdated)}
                          className="btn btn-danger btn-sm ml-2 ts-buttom btn btn-primary"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
export default UpdateProfile;
